import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

export const createFavouriteSitesApi = (db: MarlinStoreDb) => ({
  getFavouriteSites: (cognitoSub: string) =>
    ops.getFavouriteSites(db, cognitoSub),
  toggleFavouriteSite: (cognitoSub: string, siteId: number) =>
    ops.toggleFavouriteSite(db, cognitoSub, siteId),
});

export type FavouriteSitesApi = ReturnType<typeof createFavouriteSitesApi>;
